<template>
    <div class="richMenu" :class="getClass()">
        <div class="richMenu__name" :data-icoTarget="icono">
            <div>
                {{ name }}
                <i v-if="surname" class="richMenu__ref">{{ surname }}</i>
            </div>
        </div>
        <!-- esta data solo para configuración de instalación -->
        <div class="richMenu__config" v-if="$slots.config">
            <slot name="config"></slot>
        </div>
        <div class="richMenu__options">
            <slot name="options"></slot>
        </div>
    </div>
</template>

<script>
    import ui_Ico from './ui-Ico.vue';
    import ui_RichMenuOption from './ui-RichMenuOption.vue';

    export default {
        components: {
            ui_Ico,
            ui_RichMenuOption,
        },
        name: 'ui-RichMenu',
        props: {
            name: {
                type: String,
                default: '',
            },
            surname: String,
            icono: String,
            navigation: {
                // Tipo option para navegación
                type: Boolean,
                default: false,
            },
            navigationStop: {
                // Último nivel de navegación
                type: Boolean,
                default: false,
            },
            edition: {
                // Se puede editar los options
                type: Boolean,
                default: false,
            },
            select: {
                // Se pueden seleccionar los options
                type: Boolean,
                default: false,
            },
        },
        methods: {
            getClass: function() {
                var classStyles = '';

                if (this.navigation) classStyles = `${classStyles} richMenu--navigation`;
                if (this.navigationStop) classStyles = `${classStyles} richMenu--navigationStop`;

                if (this.edition) classStyles = `${classStyles} richMenu--edition`;
                if (this.select) classStyles = `${classStyles} richMenu--select`;

                return classStyles;
            },
        },
    };
</script>
